import { Icon, type IconTone } from './Icon';

/** Срок: до какого числа действует способность или дебаф. */
export function ClockIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} tone={tone}>
      <circle cx="7" cy="7" r="5.6" />
      <path d="M7 3.8 V7 L9.2 8.6" />
    </Icon>
  );
}
